import {
  actions,
  getUserByIdAsync,
  getUsersByEmailAsync,
  blockUserAsync,
  unblockUserAsync,
  setUserEmailAsync,
  setUserPasswordAsync,
  updateUserGenderAsync,
  updateUserNameAsync,
  deleteUserAsync,
  getUserGiftsAsync,
  createUserGiftAsync,
  consumeUserGiftAsync,
  getSubsicriptionHistoryAsync,
  addCustomerProductAsync,
  expireCustomerProductAsync,
  getProductByPurchaseSourceAndProductTypeAsync,
  getUserPointsAsync,
  addPointsToUserAsync,
  getUserPlansAsync,
  searchUsersByFilterAsync,
} from './slices';

export const CustomerCareActions = {
  ...actions,
  getUserByIdAsync,
  getUsersByEmailAsync,
  blockUserAsync,
  unblockUserAsync,
  setUserEmailAsync,
  setUserPasswordAsync,
  updateUserGenderAsync,
  updateUserNameAsync,
  deleteUserAsync,
  getUserGiftsAsync,
  createUserGiftAsync,
  consumeUserGiftAsync,
  getSubsicriptionHistoryAsync,
  addCustomerProductAsync,
  expireCustomerProductAsync,
  getUserPointsAsync,
  addPointsToUserAsync,
  getProductByPurchaseSourceAndProductTypeAsync,
  getUserPlansAsync,
  searchUsersByFilterAsync,
};

export * from './thunkHandlers';
